import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/Collab-Rect-TR01.png';
import './Navbar.css';
import toggleMenuImg from '../assets/icons/mobMenu.png';

const menuItems = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About Us" },
  { path: "/services", label: "Services" },
  { path: "/products", label: "Products" },
  { path: "/contact", label: "Contact Us" },
];

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  return (
    <header className="Navbar">
      <div className="Navbar-left">
        <img src={logo} className="Navbar-logo" alt="CollabTechniqs Logo" />
      </div>
      <nav className={`Navbar-right ${isMenuOpen ? "open" : ""}`}>
        <ul className="Navbar-menu">
          {menuItems.map(({ path, label }) => (
            <li key={path}>
              <NavLink
                to={path}
                className={({ isActive }) =>
                  isActive ? 'Navbar-link active' : 'Navbar-link'
                }
                end={path === '/'}
                onClick={() => setIsMenuOpen(false)}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="Navbar-toggle" onClick={toggleMenu}>
        <img src={toggleMenuImg} className="Navbar-toggle-image" alt="Toggle Menu" />
      </div>
    </header>
  );
}

export default Navbar;